<template>

  <modalo
    title="Solicitar vídeo entrevista"
    type="small"
    @hideModal="hideModal()">

    <form
      id="invite-candidate-form"
      v-on:submit.prevent="saveInvite(invite)">

      <div
        v-if="candidatesWithoutEmail.length"
        class="alert alert-warning p-3 mb-4">
        <div class="mb-2">Alguns candidatos não possuem e-mails</div>
        <select-multiple-candidates
          v-model="candidatesWithoutEmail"
          :remove="false">
          </select-multiple-candidates>
      </div>

      <div
        class="form-group"
        v-if="candidatesWithEmail.length">
        <label class="control-label">* {{ $t('Candidates') }}</label>
        <select-multiple-candidates
          v-model="candidatesWithEmail"
          :remove="false">
          </select-multiple-candidates>
      </div>

      <div class="form-group">
        <label class="control-label">* Vídeo formulário</label>
        <select-videoform
          v-model="videoformId"
          :placeholder="$t('Select a video form')"></select-videoform>
        <ValidateMessage
          :error="validateErrors.videoform_id" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="invite-candidate-form"
          class="btn btn-primary"
          :disabled="!candidatesWithEmail.length">{{ $t('Request') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectMultipleCandidates from '@/components/Fields/SelectMultipleCandidates'
import SelectVideoform from '@/components/Fields/SelectVideoform'

export default {
  name: 'MassiveInviteIntervoice',
  components: {
    SelectMultipleCandidates,
    SelectVideoform
  },
  props: [
    'initInvite'
  ],
  data () {
    return {
      loading: false,
      invite: this.defaultValues(this.initInvite),
      validateErrors: {},
      videoformId: null
    }
  },
  computed: {
    candidates () {
      return this.invite.candidates || {}
    },
    candidatesWithEmail () {
      return this
      .candidates
      .filter(candidate => {
        return candidate.email
      })
    },
    candidatesWithoutEmail () {
      return this
      .candidates
      .filter(candidate => {
        return !candidate.email
      })
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveInvite
    */
    saveInvite (data) {
      this.loading = true

      Promise.all(this.candidatesWithEmail.map(candidate => {
        return this.$store
        .dispatch('createIntervoiceInvite', {
          candidate_id: candidate._id,
          job_id: this.invite.job_id,
          videoform_id: this.videoformId
        })
      }))
      .then(() => {
        this.loading = false
        this.$emit('created', {})
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MassiveInviteIntervoice/MassiveInviteIntervoice.vue